import { setUserProjection } from "ol/proj";
import { createStore } from "vuex";
import CryptoHelper from "@/helper/CryptoHelper";

export default createStore({
  state: {
    PROJECTID: 0,
    ZONEID: "",
    currentUser: null,
    isLoggedIn: false,
    userProjects: [],
    districtProjects: [],
    currentProject: null,
  },
  getters: {
    ProjectId(state) {
      return state.PROJECTID;
    },
    ZoneId(state) {
      return state.ZONEID;
    },
    currentUser(state) {
      if (localStorage.getItem("epd-cnmp-user")) {
        let user = localStorage.getItem("epd-cnmp-user").startsWith("{")
          ? localStorage.getItem("epd-cnmp-user")
          : CryptoHelper.Decrypt(localStorage.getItem("epd-cnmp-user"));
        if (user.includes("[object Object]")) {
          return state.currentUser;
        }
        return state.currentUser || JSON.parse(user);
      }
      return state.currentUser;
    },
    isLoggedIn(state) {
      if (localStorage.getItem("epd-cnmp-user")) {
        let user = localStorage.getItem("epd-cnmp-user").startsWith("{")
          ? localStorage.getItem("epd-cnmp-user")
          : CryptoHelper.Decrypt(localStorage.getItem("epd-cnmp-user"));
        if (user.includes("[object Object]")) {
          return state.isLoggedIn;
        }
        return state.isLoggedIn || JSON.parse(user);
      }
      return state.isLoggedIn;
    },
    userProjects(state) {
      return state.userProjects;
    },
    districtProjects(state) {
      return state.districtProjects;
    },
    currentProject(state) {
      return state.currentProject;
    },
  },
  mutations: {
    setProjectId(state, payload) {
      state.PROJECTID = payload.value;
    },
    setZoneId(state, payload) {
      state.ZONEID = payload.value;
    },
    setCurrentUser(state, payload) {
      state.currentUser = payload.value;
    },
    setIsLoggedIn(state, payload) {
      state.isLoggedIn = payload.value;
    },
    setDistrictProjects(state, payload) {
      state.districtProjects = payload.value;
    },
    setUserProjects(state, payload) {
      state.userProjects = payload.value;
    },
    addUserProjects(state, payload) {
      state.userProjects.push(payload.value);
    },
    setCurrentProject(state, payload) {
      state.currentProject = payload.value;
    },
  },
  actions: {
    login(context, payload) {
      context.commit("setCurrentUser", { value: payload.user });
      context.commit("setIsLoggedIn", { value: true });
    },
    logout(context) {
      context.commit("setCurrentUser", { value: null });
      context.commit("setIsLoggedIn", { value: false });
    },
    generateNewProjectD(context) {
      var newProjectId = context.getters.ProjectId + 1;
      context.commit("setProjectId", { value: newProjectId });
    },
    addeNewProject(context, payload) {
      //After get database: change context.getters.ProjectId with max ProjectId from DB.
      context.commit("addUserProjects", { value: payload.project });
      context.commit("setCurrentProject", { value: payload.project });
    },
    setUserProjects(context, payload) {
      context.commit("setUserProjects", { value: payload.projects });
    },
    setDistrictProjects(context, payload) {
      context.commit("setDistrictProjects", {
        value: payload.districtProjects,
      });
    },
    setCurrentProject(context, payload) {
      context.commit("setCurrentProject", { value: payload.project });
    },
  },
  modules: {},
});
